/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Avail_Before_AfterInputs */

const en_cargos_avail_before_after = /** @type {(inputs: Cargos_Avail_Before_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avail (Before → After)`)
};

const es_cargos_avail_before_after = /** @type {(inputs: Cargos_Avail_Before_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disp (Antes → Despues)`)
};

/**
* | output |
* | --- |
* | "Avail (Before → After)" |
*
* @param {Cargos_Avail_Before_AfterInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_avail_before_after = /** @type {((inputs?: Cargos_Avail_Before_AfterInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Avail_Before_AfterInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_avail_before_after(inputs)
	return es_cargos_avail_before_after(inputs)
});